/**
 * This enum is an attempt to make more explicit the match between
 * navigation keys and routes.
 *
 * Not all elements are included in the navigation, but they need
 * to be defined in this enum to avoid falling back to the
 * organizations page
 */
enum PageKey {
  ActionPlanTemplates = 'action-plan-templates',
  Companies = 'companies',
  Contacts = 'contacts',
  Content = 'content',
  ContentLink = 'content-link',
  ContentUpdates = 'content-updates',
  CreateContent = 'create-content',
  CreatedContentLink = 'created-content-link',
  Deals = 'deals',
  DeletedContent = 'deleted-content',
  Denied = 'denied',
  ForgotPassword = 'forget-password',
  Insights = 'insights',
  Library = 'library',
  LogIn = 'login',
  LogOut = 'logout',
  More = 'more',
  NotFound = 'not-found',
  Organization = 'organization',
  Organizations = 'organizations',
  Plans = 'plans',
  ReferenceRequest = 'reference-request',
  ReferencesRequested = 'references-requested',
  Report = 'report',
  RequestReference = 'request-reference',
  ResetPassword = 'reset-password',
  Room = 'room',
  Rooms = 'rooms',
  RoomTemplate = 'room-template',
  RoomTemplates = 'room-templates',
  Settings = 'settings',
  SharedLink = 'shared-link',
  SharedLinks = 'shared-links',
  SignableTemplate = 'signable-template',
  SignableTemplates = 'signable-templates',
  SignUp = 'sign-up',
  Templates = 'templates',
  Zoom = 'zoom-install',
}

export enum OrganizationSettingsPages {
  Attributes = 'attributes',
  ImageGallery = 'image-gallery',
  Integrations = 'integrations',
  Notifications = 'notifications',
  Profile = 'profile',
  ReferenceCategories = 'reference-categories',
  RoomOptions = 'room-options',
  Subscription = 'subscription',
  Users = 'users',
  Permissions = 'permissions',
}

export enum PersonalSettingsPages {
  Account = 'account',
  Integrations = 'personal-integrations',
  Notifications = 'personal-notifications',
  Profile = 'profile',
}

export default PageKey;
